module.exports = __webpack_public_path__ + "static/btn 2_000012.7f82b32d.png";